/* eslint-disable */
import { getCaretPosition, getCaretPositionAndNode, setCaretAtPosition } from "@/components/items/content-editable-input/functions/helpers";
import { getMentionsClasses } from "@/functions/mentions";

export function mentions (input) {
	let caretPosition = getCaretPosition(input),
		mention = '',
		mentions = [],
		index = -1,
		childNodeData = getCaretPositionAndNode(input)

	if (childNodeData.node.nodeName === 'DIV' || childNodeData.node.nodeName === 'BR')
		return null

	let letters = childNodeData.node.data.split("")

	for (let i = 0; i < letters.length && i < caretPosition; i++) {
		let letter = letters[i]
		if (letter === '@' && (i === 0 || letters[i - 1] === ' ')) {
			index++;
			mentions.push({
				startAt: i,
				endAt: null,
				letters: []
			})
			if (mentions[index - 1])
				mentions[index - 1].endAt = i - 1
		}
		if (mentions[index])
			mentions[index].letters.push(letter)
	}

	mention = mentions.find(o => o.startAt <= caretPosition && (o.endAt >= caretPosition || !o.endAt));

	if (mention) {
		let text = mention.letters
		text.shift()
		text = text.join("")
		return {
			text: text,
			data: mention,
			caret: {
				coordinates: getCaretCoordinates(input)
			},
			index: null,
			user: null
		}
	}
	return null
}

export function mention (input, mention) {
	let html = input.innerHTML,
		mid = Math.floor(Math.random() * 100000) + 1,
		mentionText = '@' + mention.user.name,
		mentionHTML = '<div class="' + getMentionsClasses() + '" mention="' + mention.user.id + '" mid="' + mid + '" contenteditable="false">' + mentionText +'</div>',
		mentionToReplace = '@' + mention.text

	html = html.replaceAll(mentionToReplace, mentionHTML)
	input.innerHTML = html

	let node = document.querySelectorAll('[mid="' + mid + '"]')[0]
	if (!node.nextSibling) {
		input.append(document.createTextNode(' '))
	}
	setCaretAtPosition(node.nextSibling, 1)
}

function getCaretCoordinates(parent){
	const r = document.getSelection().getRangeAt(0)
	const node = r.startContainer
	const offset = r.startOffset
	const parentOffset = parent.getBoundingClientRect()
	let rect,  r2

	if (offset > 0) {
		r2 = document.createRange()
		r2.setStart(node, (offset - 1))
		r2.setEnd(node, offset)
		rect = r2.getBoundingClientRect()
		return {
			left: parentOffset.left + (rect.x - parentOffset.left),
			top: parentOffset.top,
			bottom: parentOffset.bottom
		}
	}
}

export function checkMentionsByLimit (input, limit) {
	let allowNodes = [], childNodes = input.childNodes, currentLength = 0
	console.clear()
	console.log(limit)
	// console.dir(input)
	// console.log(childNodes)
	for (let i = 0; i < childNodes.length; i++) {
		let node = childNodes[i]
		console.dir(node)
		// if (node.name === '#text') {
		// 	if (node.length + currentLength > limit)
		//
		// }
	}
}
